import { Input, Modal, Form, Row, Col } from 'antd';
import lodashValues from 'lodash/values';
import zipObjectDeep from 'lodash/zipObjectDeep';
import crudSelectors from '@redux/crudSelectors';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import { RestInputContext } from 'components/form/RestInputContext';
import FormItem from 'components/form/FormItem';
import { validateRegex } from 'utils/validator';
import {
  editInvoiceInformation,
  editOrdersTabTryBuy,
} from '@redux/ordersTabTryBuy/actions';

const TITLE_MODAL = {
  note: 'orderDetail.editNote',
  invoiceInfo: 'orderDetail.editInvoiceInfo',
  deliveryNote: 'orderDetail.editDeliveryNote',
};

const EditInfoModal = ({ formType, onCancel }) => {
  const { t } = useTranslation();
  const record = useSelector<DynamicObjectType>(
    (state) => state.ordersTabTryBuy.currentData,
  );
  const loading = useSelector(
    crudSelectors.ordersTabTryBuy.getLoadingCurrentRecord,
  );
  const [loadinInvoice, setLoadingInvoice] = useState(false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleSubmit = (values) => {
    const formatData = {};
    Object.keys(values).map((key) => {
      formatData[key] =
        values[key] && typeof values[key] === 'string'
          ? values[key].trim()
          : values[key];
    });
    form.setFieldsValue({
      ...formatData,
      ...zipObjectDeep(Object.keys(formatData), lodashValues(formatData)),
    });

    form.validateFields().then((values) => {
      const payload = zipObjectDeep(Object.keys(values), lodashValues(values));
      if (formType === 'invoiceInfo') {
        setLoadingInvoice(true);
        dispatch(
          editInvoiceInformation({
            data: {
              id: record?.id,
              data: payload,
            },
            options: {},
          }),
        ).then(() => {
          setLoadingInvoice(false);
          onCancel();
          form.resetFields();
        });
      } else {
        dispatch(
          editOrdersTabTryBuy({
            data: {
              id: record?.id,
              ...payload,
            },
            options: {},
          }),
        ).then(() => {
          onCancel();
          form.resetFields();
        });
      }
    });
  };

  const onError = (e) => {
    console.log('e', e);
  };

  useEffect(() => {
    if (!formType) {
      form.resetFields();
    }
    // eslint-disable-next-line
  }, [formType]);

  return (
    <Modal
      open={!!formType}
      onCancel={onCancel}
      title={t(TITLE_MODAL[formType])}
      onOk={() => form.submit()}
      width={700}
      okButtonProps={{
        loading: loadinInvoice || loading,
      }}
    >
      <Form
        form={form}
        onFinishFailed={onError}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={record}
      >
        <RestInputContext.Provider value={{ form, record }}>
          <Row gutter={[14, 14]}>
            {(() => {
              if (formType === 'note')
                return (
                  <Col span={24}>
                    <FormItem name="note" label="orders.note">
                      <Input.TextArea />
                    </FormItem>
                  </Col>
                );
              if (formType === 'deliveryNote')
                return (
                  <Col span={24}>
                    <FormItem name="deliveryNote" label="orders.deliveryNote">
                      <Input.TextArea />
                    </FormItem>
                  </Col>
                );
              if (formType === 'giftNote')
                return (
                  <Col span={24}>
                    <FormItem name="giftNote" label="orders.giftNote">
                      <Input.TextArea />
                    </FormItem>
                  </Col>
                );
              if (formType === 'invoiceInfo')
                return (
                  <>
                    <Col span={24}>
                      <div className="font-medium text-[16px]">
                        {t('orders.invoiceInformation')}
                      </div>
                    </Col>
                    <Col span={24}>
                      <FormItem
                        name={['invoiceInfo', 'businessName']}
                        label="invoiceInfo.businessName"
                      />
                    </Col>
                    <Col span={24}>
                      <FormItem
                        // rules={[
                        //   {
                        //     pattern: /^[0-9]{10}$/,
                        //     message: t('orders.taxCodeValidate'),
                        //   },
                        // ]}
                        name={['invoiceInfo', 'taxCode']}
                        label="invoiceInfo.taxCode"
                      />
                    </Col>
                    <Col span={24}>
                      <FormItem
                        name={['invoiceInfo', 'address']}
                        label="invoiceInfo.address"
                      />
                    </Col>
                    <Col span={24}>
                      <FormItem
                        rules={[
                          {
                            pattern: validateRegex.phoneFull,
                            message: t(
                              'common.input.phone.validateMsg.invalid',
                            ),
                          },
                        ]}
                        name={['invoiceInfo', 'telephone']}
                        label="invoiceInfo.telephone"
                      />
                    </Col>
                    <Col span={24}>
                      <FormItem
                        name={['invoiceInfo', 'email']}
                        label="invoiceInfo.email"
                      />
                    </Col>
                  </>
                );
            })()}
          </Row>
        </RestInputContext.Provider>
      </Form>
    </Modal>
  );
};

export default EditInfoModal;
